import type { RenderItemProps } from '@/components/StructuredVirtualList'

import { DriverAssignmentItem } from './components/DriverAssignmentItem'

type Props = RenderItemProps<'driverAssignments'>

export function Item(props: Props) {
  return props.type === 'item' ? <DriverAssignmentItem {...props} /> : null
}
